<app-header></app-header>
<div class="breadcrumb">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <span><a class="cursor-link" (click)="goToTheme()">Preview</a> > Education > Experience > Skills > Languages > <strong>Hobbies</strong></span>
      </div>
    </div>
  </div>
</div>
<div class="addHobbies">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <div class="">
          <h2>Add Hobbies</h2>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="tinyMCE">
          <!--<ckeditor [(ngModel)]="resume.hobbies"></ckeditor>-->
          <!-- <app-tinymce [(ngModel)]="resume.hobbies"></app-tinymce> -->
          <editor [init]="utilService.editorConfig" [(ngModel)]="resume.hobbies"></editor>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="titleBody">
          <div class="titleAdd">
            <div class="titleAdd__plus" *ngFor="let desc of descs" (click)="append(resume, desc)">
              <div class="titleAdd__text"><span>Add</span></div>
              <div class="titleAdd__body" [innerHTML]="desc"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6 col-4">
        <div class="addHobbies__buttons">
          <button class="btn btn-default" routerLink="/resume/lang">Back</button>
        </div>
      </div>
      <div class="col-sm-6 col-8 text-right">
        <div class="addHobbies__buttons">
          <button class="btn btn-default" routerLink="/resume/accomplishments">Skip</button>
          <button class="btn btn-primary" (click)="save()">Save &amp; Next</button>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
